module.exports = __webpack_public_path__ + "img/productSatellite_15.ff3ac366.png";